// FeedStoryRow.js
import FeedStoryProvider from '../container/FeedStoryProvider.js';
import StoryRow from '../component/StoryRow.jsx';

export default FeedStoryProvider(StoryRow);
